import { z } from "zod";

export const dashboardKpiConnectionsSchema = z.object({
  total: z.number(),
  active: z.number(),
  idle: z.number(),
  series: z.array(z.number()),
});

export const dashboardKpiActiveJobsSchema = z.object({
  count: z.number(),
  running: z.array(
    z.object({
      id: z.string().uuid(),
      type: z.string(),
    }),
  ),
  series: z.array(z.number()),
});

export const dashboardKpiAppsTrackedSchema = z.object({
  total: z.number(),
  newThisWeek: z.number(),
  series: z.array(z.number()),
});

export const dashboardPendingChangeSampleSchema = z.object({
  draftId: z.string().uuid(),
  connectionId: z.string().uuid(),
  appId: z.string(),
  appName: z.string().nullable(),
  variablePending: z.number(),
  masterItemPending: z.number(),
  conflictCount: z.number(),
});

export const dashboardKpiPendingChangesSchema = z.object({
  total: z.number(),
  variables: z.number(),
  masterItems: z.number(),
  conflicts: z.number(),
  sampleItems: z.array(dashboardPendingChangeSampleSchema),
  series: z.array(z.number()),
});

export const dashboardKpiFailedRunsSchema = z.object({
  count: z.number(),
  lastFailureDaysAgo: z.number().nullable(),
  series: z.array(z.number()),
});

export const dashboardConnectionsStripItemSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  status: z.enum(["active", "idle", "error"]),
  appCount: z.number().nullable(),
});

export const dashboardOverviewSchema = z.object({
  generatedAt: z.string(),
  syncGroupsOnSchedule: z.number(),
  totalSyncGroups: z.number(),
  kpi: z.object({
    connections: dashboardKpiConnectionsSchema,
    activeJobs: dashboardKpiActiveJobsSchema,
    appsTracked: dashboardKpiAppsTrackedSchema,
    pendingChanges: dashboardKpiPendingChangesSchema,
    failedRuns7d: dashboardKpiFailedRunsSchema,
  }),
  heatmap: z.array(z.number()),
  connectionsStrip: z.array(dashboardConnectionsStripItemSchema),
});

export type DashboardOverview = z.infer<typeof dashboardOverviewSchema>;
export type DashboardKpiConnections = z.infer<typeof dashboardKpiConnectionsSchema>;
export type DashboardKpiActiveJobs = z.infer<typeof dashboardKpiActiveJobsSchema>;
export type DashboardKpiAppsTracked = z.infer<typeof dashboardKpiAppsTrackedSchema>;
export type DashboardKpiPendingChanges = z.infer<typeof dashboardKpiPendingChangesSchema>;
export type DashboardKpiFailedRuns = z.infer<typeof dashboardKpiFailedRunsSchema>;
export type DashboardPendingChangeSample = z.infer<typeof dashboardPendingChangeSampleSchema>;
export type DashboardConnectionsStripItem = z.infer<typeof dashboardConnectionsStripItemSchema>;

export const dashboardOverviewResponseSchema = z.object({
  data: dashboardOverviewSchema,
});

export type DashboardOverviewResponse = z.infer<typeof dashboardOverviewResponseSchema>;
